import { useCallback, useEffect, useState } from 'react';
import { AButton, AInput, ASelect, ATitle } from '../../../components';
import { SchedulesMissedReport } from '../../../shared/reports/Schedule';
import { ISchedule, IScheduleStatus, IUser } from '../../../shared/interfaces';
import {
  CalendarOutlined,
  FileTextOutlined,
  LeftCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import api from '../../../services/api';
import { useToast } from '../../../hooks/toast';
import { useNavigate } from 'react-router-dom';
import {
  HeaderPrintScheduleContainer,
  SearchScheduleContainer,
} from './styles';

const SchedulesPrint: React.FC = () => {
  const { addToast } = useToast();
  const navigate = useNavigate();
  const [professionals, setProfessionals] = useState<IUser[]>([]);
  const [professionalId, setProfessionalId] = useState<string | null>(null);
  const [schedulesStatus, setSchedulesStatus] = useState<IScheduleStatus[]>([]);
  const [status, setStatus] = useState<string>();
  const [start, setStart] = useState<string>('');
  const [end, setEnd] = useState<string>('');
  const [schedules, setSchedules] = useState<ISchedule[]>([]);

  const loadSchedules = useCallback(async () => {
    try {
      const response = await api.post('/schedules/list', {
        start,
        color: status,
        end,
        professional_id: professionalId,
      });
      setSchedules(response.data);
    } catch (err) {
      addToast({
        type: 'error',
        title: 'Erro',
        description: 'Erro ao listar os agendamentos',
      });
    }
  }, [start, end, status, professionalId]);

  const listProfessionals = useCallback(async () => {
    try {
      const response = await api.get(`/professionals/select`);
      setProfessionals(response.data);
    } catch (err) {
      addToast({
        type: 'error',
        title: 'Erro',
        description: 'Erro ao listar os profissionais',
      });
    }
  }, [addToast]);

  const listSchedulesStatus = useCallback(async () => {
    await api
      .get(`/schedules-status/select/all`)
      .then((response) => {
        setSchedulesStatus(response.data);
      })
      .catch((error) => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: `${error.response.data.message}`,
        });
      });
  }, []);

  useEffect(() => {
    listProfessionals();
    listSchedulesStatus();
    loadSchedules();
  }, []);

  return (
    <>
      <HeaderPrintScheduleContainer>
        <ATitle icon={<FileTextOutlined />}>Relatório de agendamentos </ATitle>
        <AButton
          type="default"
          onClick={() => navigate('/schedules')}
          icon={<LeftCircleOutlined />}
        >
          Voltar
        </AButton>
      </HeaderPrintScheduleContainer>
      <SearchScheduleContainer>
        <ASelect
          placeholder="Status"
          value={status}
          onChange={(e) => setStatus(e)}
          style={{ width: 160 }}
          allowClear
          options={schedulesStatus.map((status) => ({
            label: status.description,
            value: status.color,
          }))}
        />

        <AInput
          type="date"
          prefix={<CalendarOutlined />}
          value={start || ''}
          onChange={(e) => setStart(e.target.value)}
        />

        <AInput
          type="date"
          prefix={<CalendarOutlined />}
          value={end || ''}
          onChange={(e) => setEnd(e.target.value)}
        />

        <ASelect
          placeholder="Profissional"
          value={professionalId}
          onChange={(e) => setProfessionalId(e)}
          style={{ width: 170 }}
          allowClear
          options={professionals.map((prof) => ({
            label: prof.name,
            value: prof.id,
          }))}
        />
        <AButton
          type="primary"
          style={{ marginTop: -5 }}
          icon={<SearchOutlined />}
          onClick={loadSchedules}
        >
          Buscar
        </AButton>
      </SearchScheduleContainer>
      <SchedulesMissedReport schedules={schedules} />
    </>
  );
};

export default SchedulesPrint;
